import { Pipe, PipeTransform } from '@angular/core';
import { formatInstallmentFrequency } from '../utils/duration.utils';

@Pipe({
  name: 'installment',
  standalone: false,
})
export class InstallmentPipe implements PipeTransform {
  transform(installments?: number, duration?: number): string {
    if (!duration || !installments) return '';

    return formatInstallmentFrequency(duration, installments);
  }
}
